import { v4 as uuidv4 } from "uuid";
export class AdjustEntryModel {
    constructor() {
        this.id = uuidv4();
        this.start = 0;
        this.end = 0;
        this.initialStart = 0;
        this.initialEnd = 0;
        this.startTime = "";
        this.endTime = "";
        this.isRunning = false;
        this.isSplitted = false;
        this.taskId = "";
        this.description = "";
        this.entryAtWork = false;
        this.isDescriptionChanged = false;
        this.isStopped = false;
        this.upFillApplicable = false;
        this.downFillApplicable = false;
        this.upFillHover = "";
        this.downFillHover = "";
    }
}
export default class AdjustEntry extends AdjustEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
